import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-scroll';
import { useIsDesktop, useDate as getDate } from '../../../hooks';

import './_calendarHeader.scss';
import DownloadButton from '../../common/DownloadButton';

function CalendarHeader ({ data, concertProgram, style, past }) {
  const [scrollOffset, setScrollOffset] = useState(0);
  const [headLineHeight, setHeadLineHeight] = useState(0);
  const [windowHeight, setWindowHeight] = useState(0);

  const isDesktop = useIsDesktop(768);

  const months = [
    { key: 'JAN', name: 'JANUARY' },
    { key: 'FEB', name: 'FEBRUARY' },
    { key: 'MAR', name: 'MARCH' },
    { key: 'APR', name: 'APRIL' },
    { key: 'MAY', name: 'MAY' },
    { key: 'JUN', name: 'JUNE' },
    { key: 'JUL', name: 'JULY' },
    { key: 'AUG', name: 'AUGUST' },
    { key: 'SEP', name: 'SEPTEMBER' },
    { key: 'OCT', name: 'OCTOBER' },
    { key: 'NOV', name: 'NOVEMBER' },
    { key: 'DEC', name: 'DECEMBER' },
  ];

  const dates = [];
  const concertIds = [];
  data.forEach((item) => {
    if (!dates.includes(item.date)) {
      dates.push(item.date);
      concertIds.push({ id: item.id, day: getDate(item.date).day });
    }
  });

  const concertMonths =
    data && data.length
      ? [...new Set(data && data.map((el) => getDate(el.date).month))]
      : [];

  useEffect(() => {
    setScrollOffset(document.getElementById('concertListHead').clientHeight);
    setHeadLineHeight(document.getElementById('headLine').clientHeight);
    setWindowHeight(window.innerHeight);
  }, []);

  function calendarItemsMobileScroll (scrollItem) {
    window.addEventListener('scroll', (e) => {
      const item = document.querySelector('.calendar-item.active');
      if (item) {
        scrollItem.scrollTo(item.offsetLeft, 0);
      }
    });
  }

  function handleCalendarChange (event, date) {
    const { month } = getDate(date);

    const months = document.querySelectorAll('.calendar-month');
    months.forEach((m) => {
      if (month === m.dataset.month) {
        m.classList.add('active');
      } else {
        m.classList.remove('active');
      }
    });

    const itemsList = document.querySelector('.calendar__items__parent');

    calendarItemsMobileScroll(itemsList);
  }

  return past ? (

    <div id='concertListHead' style={style} className='calendar-head'>
      <h1 className='calendar-title'>PAST EVENTS</h1>

    </div>

  ) : (
    <div id='concertListHead' style={style} className='calendar-head'>
      <h1 className='calendar-title'>UPCOMING EVENTS</h1>
      {isDesktop ? (
        <div className='calendar-desktop-section'>
          <h2 className='calendar-year'>2025</h2>

          {months &&
            months.length &&
            months.map((m, i) => {
              return (
                concertMonths.find((mon) => mon === m.key) && (
                  <>
                    <ul className='calendar-items'>
                      <p key={`${m.key}-${i}`} data-month={m.key} className='calendar-month'>
                        {m.name}
                      </p>
                      {dates &&
                        dates.length &&
                        dates
                          .filter((date) => {
                            const { month } = getDate(date);

                            return month === m.key;
                          })
                          .map((date, i) => {
                            const { weekDay, day } = getDate(date);
                            const item = concertIds.find(
                              (item) => item.day === day
                            );
                            return (
                              <li key={item.id} className='calendar-item'>
                                <Link
                                  activeClass='active'
                                  spy
                                  smooth
                                  duration={500}
                                  to={String(item.id)}
                                  offset={
                                    -(scrollOffset + headLineHeight + 100)
                                  }
                                  onSetActive={(e) =>
                                    handleCalendarChange(e, date)
                                  }
                                >
                                  <span className='calendar-item-point'>
                                    {day}
                                  </span>
                                </Link>
                                <sub>{weekDay.charAt(0)}</sub>
                              </li>
                            );
                          })}
                    </ul>
                  </>
                )
              );
            })}
        </div>
      ) : (
        <>
          <h2 className='calendar-year'>2024</h2>
          <br />
          <div className='calendar__list'>
            {data && data.length !== 0 && (
              <>
                <div className='months'>
                  {months &&
                    months.length &&
                    months.map((m, i) => {
                      return (
                        concertMonths.find((mon) => mon === m.key) && (
                          <p
                            key={i}
                            data-month={m.key}
                            className='calendar-month'
                          >
                            {m.name}
                          </p>
                        )
                      );
                    })}
                </div>
                <div className='calendar__items__parent'>
                  <div className='calendar-items'>
                    {dates &&
                      dates.length &&
                      dates.map((date) => {
                        const { weekDay, day } = getDate(date);
                        const item = concertIds.find(
                          (item) => item.day === day
                        );
                        return (
                          <Link
                            key={item.id}
                            className='calendar-item'
                            activeClass='active'
                            spy
                            smooth
                            duration={500}
                            to={String(item.id)}
                            onSetActive={(e) =>
                              handleCalendarChange(e, date)
                            }
                            offset={-((windowHeight / 100) * 38)}
                          >
                            <span className='calendar-item-point'>{day}</span>
                            <sub>{weekDay.charAt(0)}</sub>
                          </Link>
                        );
                      })}
                  </div>
                </div>
              </>
            )}
          </div>
        </>
      )}

      <div className='calendar-slide'>
        {concertProgram &&
          Object.keys(concertProgram).length &&
          concertProgram.url !== '' && (
            <div className='concert__section concert__download'>
              <p
                dangerouslySetInnerHTML={{
                  __html: concertProgram && concertProgram?.label,
                }}
              />

              <DownloadButton
                downloadUrl={concertProgram && concertProgram?.url}
                btnTitle='download'
              />
            </div>
          )}
      </div>
    </div>
  );
}

CalendarHeader.propTypes = {
  data: PropTypes.array.isRequired,
  concertProgram: PropTypes.object,
  style: PropTypes.object,
};

export default CalendarHeader;
